const decodeQueryValue = (value = "") => {
    const queryValue = String(value || "").trim();
    if (!queryValue) {
        return "";
    }

    try {
        return decodeURIComponent(queryValue.replace(/\+/g, "%20")).trim();
    } catch (error) {
        return queryValue;
    }
};

const getDisplaySchoolName = ({
    querySchoolName = "",
    schoolName = "",
    formatSchoolName,
} = {}) => {
    const schoolNameFromQuery = decodeQueryValue(querySchoolName);
    if (schoolNameFromQuery) {
        return schoolNameFromQuery;
    }

    if (typeof formatSchoolName === "function") {
        return formatSchoolName(schoolName);
    }

    return schoolName;
};

module.exports = {
    decodeQueryValue,
    getDisplaySchoolName,
};
